<template>
  <v-container fluid class="pa-6" style="height: 70vh;">
    <v-row justify="center">
        <v-col cols="12" lg="12" xl="8">
            <v-card elevation="4" class="rounded-lg">
                <v-card-title class="blue-grey-lighten-4">
                    Leave Process
                </v-card-title>

                <v-card-text fluid class=" d-flex align-center justify-center">
                            <v-form ref="yearForm" @submit.prevent="submit">
                                <v-row>
                                    <v-col cols="12">
                                      <v-autocomplete
                                        v-model="year.value.value"
                                        :error-messages="year.errorMessage.value"
                                        :items="getYearList"
                                        item-title="label"
                                        item-value="value"
                                        variant="outlined"
                                        label="Enter Year"
                                        density="compact"
                                        bg-color="grey-lighten-4"
                                        prepend-icon=""
                                        prepend-inner-icon="mdi-calendar-month"
                                        clearable
                                        style="min-width: 200px;"
                                      ></v-autocomplete>
                                    </v-col>

                                    <v-col cols="12" class="text-center mt-2">
                                        <v-btn
                                        style="height: 40px; width: 150px;"
                                        color="primary"
                                        variant="flat"
                                        type="button"
                                        size="small"
                                        @click="submitForm()"
                                        :loading="loading"
                                        >
                                        Process
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-form>

                </v-card-text>

            </v-card>
        </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ref, computed , watch } from "vue";
import { toast } from "vue3-toastify";
import { useForm, useField } from "vee-validate";
import * as yup from "yup";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

export default {
  name: "JournalVoucherEntry",

  data: () => ({
    loading: false,
  }),

  created() {
        
        
  },

  computed: {
    getYearList() {
      const currentYear = new Date().getFullYear();
      const years = [];
      for (let i = currentYear - 1; i <= currentYear; i++) {
          years.push(i);
      }
      return years;
    },
  },

  methods: {

  },

  setup() {

   

    const { handleSubmit} = useForm({
      validationSchema: yup.object({
        // year: yup.number().required().label("Year"),
      }),
    });

    const submitForm = (status) => {
      submit();                       
    };

    const store = useStore();
    const year = useField("year");
    const loading = ref(false);
    const router = useRouter();


    const submit = handleSubmit((values) => {
      loading.value = true;
      const payload = {
        year: year.value.value,
      };
      store  .dispatch("leaveProcess", payload)
        .then((response) => {
          loading.value = false;
          toast.success(response.data.message, {
            timeout: 2000,
          });
        })
        .catch((error) => {
            loading.value = false;
            toast.error(
                error.response?.data?.message || "Failed to save voucher"
            );
        })
        .finally(() => {
          loading.value = false;
        });
    });

    return {
      submit,
      submitForm,
      year,
      loading,
    };
  },

  mounted() {

  }

};
</script>